import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=b7cc2028&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=b7cc2028&prod&lang=scss&scoped=true"
import style1 from "./VideoView.vue?vue&type=style&index=1&id=b7cc2028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cc2028",
  null
  
)

export default component.exports